var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-container-page display-col full-height"},[_c('div',{staticClass:"search-container"},[_vm._t("search")],2),_c('div',{staticClass:"table-container flex1"},[_vm._t("table")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }